import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import ServicePage from '../../../shared/servicePage/ServicePage';
import sendImageData from './SendImage.json';
import '../../Technical.css';

class SendImage extends Component {
    render() {
        var back = this.props.match.path.substring(0, this.props.match.path.lastIndexOf("/"));
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <ServicePage ServiceData={sendImageData} backLink={back} />
            </div>
        )
    }
}

SendImage.propTypes = {
    match:PropTypes.object,
    path: PropTypes.string
  }

export default SendImage;